// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import JapanMap from '../_raw/ui/icon_japan_map.svg';
import withIconProps from '../withIconProps';

export default withIconProps(JapanMap);
